import React from 'react';
import { Layout, Page, Card, BlockStack, Button, Text } from "@shopify/polaris";

import Carousel from "../../components/Carousel";
import envelope from "../../assets/images/misc/iterable-email.svg";
import cart from "../../assets/images/misc/iterable-cart.svg";
import magnifier from "../../assets/images/misc/iterable-search.svg";

import styles from "./Onboarding.module.css";

const carouselSettings = {
  showArrows: false,
  showStatus: false,
  showThumbs: false,
};

function Onboarding() {
  return (
    <Page title="Onboarding">
      <Layout>
        <Layout.Section variant="oneHalf">
          <Card>
            <div className={styles.cardContent}>
              <Carousel settings={carouselSettings}>
                <div className={styles.slide}>
                  <img
                    src={envelope}
                    alt="Envelope"
                    className={styles.slideImage}
                  />

                  <BlockStack>
                    <Text as="h2">Iterable Platform</Text>

                    <p>
                      Iterable is the growth marketing platform that enables
                      brands to create, execute and optimize cross-channel
                      campaigns with unparalleled data flexibility.
                    </p>
                  </BlockStack>
                </div>

                <div className={styles.slide}>
                  <img src={cart} alt="Cart" className={styles.slideImage} />

                  <BlockStack>
                    <Text as="h2">Lifecycle Marketing Made Simple</Text>

                    <p>
                      Iterable’s Integration allows you to engage your customers
                      at each touchpoint of their buying journey- from sign-up
                      to check-out and beyond. Drive user purchases and nurture
                      your customer base with relevant cross-channel messaging.
                    </p>
                  </BlockStack>
                </div>

                <div className={styles.slide}>
                  <img
                    src={magnifier}
                    alt="Magnifier"
                    className={styles.slideImage}
                  />

                  <BlockStack>
                    <Text as="h2">Setup and Support</Text>

                    <p>
                      Please contact your Implementation or Customer Success
                      Manager for assistance in setting up your Iterable
                      Integration with your Iterable account.
                    </p>
                  </BlockStack>
                </div>
              </Carousel>
            </div>
          </Card>
        </Layout.Section>

        <Layout.Section variant="oneHalf">
          <Card>
            <div className={styles.cardContent}>
              <BlockStack>
                <Text as="h2">Iterable + Shopify</Text>

                <p>
                  Iterable integrates with Shopify, enabling you to automate
                  your multi-channel marketing strategy based on user actions in
                  your Shopify e-commerce website. Simply drop your Iterable API
                  key into the Iterable Integration to boost retention and ROI
                  with campaign strategies like cart abandonment and repeat
                  purchase.
                </p>

                <p>
                  The Iterable Integration forwards the properties and actions
                  of your Shopify store users to Iterable. Once enabled, the
                  application will sync your customers' details, their actions
                  on site (cart updates, purchases, product views), and product
                  information in real time with your Iterable project. In
                  addition, there is the option to perform a backfill of your
                  store to bring in historical users' profiles and their past
                  orders.
                </p>

                <p>
                  Note: The Iterable Integration requires an active Iterable
                  account.
                </p>
              </BlockStack>
            </div>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <div className={styles.nextButtonContainer}>
            <Button variant="primary" url="/settings/new">
              Next
            </Button>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
};


export default Onboarding;
